import axios from 'axios'
import Vue from 'vue'
import BadResponseInterceptor from './BadResponseInterceptor.js'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

const EventBus = new Vue()

export {instance as default, EventBus}



// WEBPACK FOOTER //
// ./src/lib/api/index.js